import React from 'react'
import Hero from '../components/hero';

const Home = () => {
  return <Hero id="home" />;
}

export default Home